module.exports = __webpack_public_path__ + "img/grow3.bc274c14.png";